import type {
    AttemptEvidence,
    ObservationMode,
} from "./handoff-observation.contract";

export function newContactAttemptId() {
    return crypto.randomUUID();
}

export function attemptEvidence<Mode extends ObservationMode>(
    attemptId: string,
    mode: Mode,
): AttemptEvidence & { observation_mode: Mode } {
    return {
        attempt_id: attemptId,
        evidence_schema_version: 2,
        observation_mode: mode,
        handoff_confirmation: "unconfirmed",
    };
}
